export default "__VITE_ASSET__CPaj4AK$__"